import { create} from "zustand"
import {ViewerMode, ViewerModeEnum, viewerModeFactory} from "./viewerState/ViewerMode/ViewerMode"

export enum ViewerLoadingStateEnum {
    Initial = "Initial",
    Loading = "Loading",
    Loaded = "Loaded",
    Staged = "Staged",
    ProductsRendered = "ProductsRendered",
    Error = "Error"
}

interface ViewerState
{
    viewerMode: ViewerMode | undefined;
    isDebugMode: boolean;
    loadingState: ViewerLoadingStateEnum; // Optional: to track the loading state of the viewer

    
    setViewerMode: (mode: ViewerModeEnum) => void;

    setLoadingState: (state: ViewerLoadingStateEnum) => void; // Optional: to set the loading state


    toggleDebugMode: () => void;
    setIsDebugMode: (mode: boolean) => void;
}

export const useViewerStateStore = create<ViewerState>()(
    (set, get) => ({
        isDebugMode: false,
        viewerMode: undefined,
        loadingState: ViewerLoadingStateEnum.Initial, // Default to Initial state

        setViewerMode: (mode: ViewerModeEnum) => 
            set({viewerMode: viewerModeFactory(mode)}),

        toggleDebugMode: () => 
            set({ isDebugMode: !get().isDebugMode }),
        
        setIsDebugMode: (mode: boolean) => 
            set({ isDebugMode: mode }),
        
        setLoadingState: (state: ViewerLoadingStateEnum) => 
            set({ loadingState: state }),
    })
);
